// src/features/records/components/GalleryView/layout/config.js

export const JUSTIFIED_GRID_GAP = 4;
export const JUSTIFIED_GRID_MIN_SCALE = 0.65;
export const JUSTIFIED_GRID_MAX_SCALE = 1.3;

/**
 * Responsive target row height resolver shared between live and skeleton grids.
 * Mirrors the breakpoints defined for the justified layout.
 */
export function resolveJustifiedRowHeight(width) {
  if (!width) return 200;
  if (width < 480) return 160;
  if (width < 768) return 180;
  if (width < 1280) return 220;
  return 260;
}

export default resolveJustifiedRowHeight;
